<template>
    <div class="ssml-template-control ssml-multitemplate-control">
        <div class="ssml-multitemplate-control__templates">
            <!-- no templates -->
            <div v-if="!templates.length" class="ssml-multitemplate-control__template">
                <SsmlTemplateControl :attribute="attribute" @update="addTemplate" />
            </div>
            <div
                v-for="template in templates"
                :key="template.id"
                class="ssml-multitemplate-control__template"
            >
                <SsmlTemplateControl
                    :value="template.value"
                    :attribute="attribute"
                    @update="updateTemplate($event, template)"
                />
            </div>
        </div>
        <div v-if="templates.length" class="ssml-multitemplate-controll__add">
            <button class="button button--fullwidth" type="button" @click="addTemplate()">
                + add item
            </button>
        </div>
    </div>
</template>

<script>
import { makeid } from '@speechki-frontend/shared/helpers/functions';

import SsmlTemplateControl from './SsmlTemplateControl';

export default {
    name: 'SSMLMulitemplateControl',
    components: {
        SsmlTemplateControl
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        attribute: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            templates: []
        };
    },

    computed: {
        delimiter() {
            return this.attribute.delimiter;
        },
        final() {
            if (!this.templates.length) return '';

            return this.templates.map(t => t.value).join(this.delimiter);
        }
    },

    watch: {
        final() {
            this.$emit('update', this.final);
        }
    },

    created() {
        if (this.value) {
            this.parseValue();
        }
    },

    methods: {
        addTemplate(value = '') {
            const id = makeid();
            this.templates.push({ id, value });
        },
        removeTemplate(template) {
            const index = this.templates.indexOf(template);
            this.templates.splice(index, 1);
        },
        updateTemplate(value, template) {
            if (!value) {
                this.removeTemplate(template);
                return;
            }

            template.value = value;
        },
        parseValue() {
            this.value.split(this.delimiter).forEach(value => {
                this.templates.push({ id: makeid(), value });
            });
        }
    }
};
</script>
